import 'css-chunksrc/client/scenes/resourcesListingConfiguration/form/columns/styles.scss';export default {
  "columns": "_columns_f7m23_1",
  "columnWrapper": "_columnWrapper_f7m23_7",
  "column": "_column_f7m23_1",
  "iconBox": "_iconBox_f7m23_27",
  "icon": "_icon_f7m23_27",
  "columnIcon": "_columnIcon_f7m23_45",
  "hidden": "_hidden_f7m23_54"
};